import { 
  Box, 
  Button, 
  Chip,
  Typography,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { styled } from "@mui/system";
import { CalendarObject } from "../../../../types/whatsapp";

const TypographyStyled = styled(Typography)({
  display: 'flex',
  fontStyle: 'normal',
  fontWeight:  500,
  lineHeight: "1.625rem",
  fontSize: "1rem"
});

const ButtonStyled = styled(Button)({
  color: '#616161', border: '1px solid #B0B0B0',
  '&:hover':{ border: '1px solid #B0B0B0' },
});

const BoxStyled = styled(Box)({
  gap: '0.5rem',
  display: 'flex'
});

interface PropsInstance {
  calendar: CalendarObject;
  onEdit: () => void;
  onDelete: () => void;
}

export function CalendarBox({ 
  calendar,
  onEdit,
  onDelete
}: PropsInstance){

  return (
    
    <Box 
      sx={{  
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#F2F3F5',
        borderWidth: '1px 0px',
        border: 'solid #F2F3F5',
        padding: '1rem 2.5rem',
        marginBottom: '0.5rem'
      }}
    >
          
      <BoxStyled flexDirection={'column'}>
        <TypographyStyled fontSize={'1rem'}> {calendar.titulo} </TypographyStyled>
        <Chip 
          label={calendar.ativo ? 'Ativa' : 'Inativa'} 
          size={'small'} 
          sx={{ 
              padding: '0px 0.5rem',
              gap: '0.625rem',
              borderRadius: '0.25rem',
              lineHeight: '22px',
              letterSpacing: '0.05rem',
              fontSize: '12px', 
              maxWidth: '3.8125rem',
              background: calendar.ativo ? '#52C41A' : '#B02F2F',
            '& .MuiChip-label': {
              padding: 0, 
              color:'#FFF',
            }
          }} 
        />
      </BoxStyled>

      <BoxStyled flexDirection={'column'}>
        <TypographyStyled fontSize={'1rem'}> Palavra-chave </TypographyStyled>
        <TypographyStyled sx={{ fontSize:'0.875rem' }}> {calendar.palavra_chave} </TypographyStyled>
      </BoxStyled>

      <BoxStyled flexDirection={'column'}>
        <TypographyStyled fontSize={'1rem'}> Descrição </TypographyStyled>
        <TypographyStyled sx={{ fontSize:'0.875rem' }}> {calendar.descricao} </TypographyStyled>
      </BoxStyled>

      <BoxStyled sx={{ p:0, alignItems: 'center', gap:'1rem' }}>
        <ButtonStyled variant="outlined" 
          sx={{ width: '2.5rem', height: '2.5rem', padding: 0, borderColor: '#1E1F21'}}
          onClick={onDelete}
        >
          <DeleteOutlineOutlinedIcon />
        </ButtonStyled >

        <ButtonStyled sx={{ borderColor: '#1E1F21' }} variant="outlined" onClick={onEdit}>  
          Configurar chatbot
        </ButtonStyled>
        
      </BoxStyled>

    </Box>
  );
}